// Bojan Nikolic <bojan@bnikolic.co.uk> 2019
import React, { Component } from "react";
import Card  from "react-bootstrap/Card";

import "./EResult.css";

import ReactMarkdown from "react-markdown";

// A result from the expert system -- no input is solited
export default class EResult extends Component {

  constructor(props) {
    super(props);
    this.cardDiv = React.createRef();
  }

  componentDidUpdate() {
    if (this.props.attent)
      this.cardDiv.current.scrollIntoView({behaviour: 'smooth'});
  }

  render() {
    return (
	<div ref={this.cardDiv}>
	<Card ref={this.props.ref}
	     className={this.props.hi ? "EResultHi" : "EResult"} >
	     <Card.Body>
	     <ReactMarkdown source={this.props.content} />	    
	     </Card.Body>	
	</Card>
    </div>);
  }
}

